// We will map mari result to this enum, indicating the full statuses
// the allowed status and not allowed status depends on the sanctions field in the masri api response
// the not found status is when the user is not found in the masri api ( returns 404 )
// the not supported status is when the user is not lebanese
export enum EMasriVerificationStatus {
  // Was added only on the front-end to indicate that the verification request is in progress.
  LOADING = 'LOADING',
  // Was added only on the front-end to indicate that the verification request failed.
  ERROR = 'ERROR',
  // in case the masri api returned that the user has no sanctions
  ALLOWED = "ALLOWED",
  // in case the masri api returned that the user has sanctions
  NOT_ALLOWED = "NOT_ALLOWED",
  // in case the masri api returned not found
  NOT_FOUND = "NOT_FOUND",
  // in case the verification is not supported ( not lebanese user )
  NOT_SUPPORTED = "NOT_SUPPORTED",
}
